module.exports = __webpack_public_path__ + "img/bicycle.be5030ca.webp";